import Head from 'next/head';
import { memo } from 'react';

import { defaultMeta } from 'components/layout/PageMeta';
import FavIcons from 'components/layout/FavIcons';

export const GlobalHead = memo(() => (
  <Head>
    <title>{defaultMeta.title}</title>
    <FavIcons />

    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0"
    />

    <meta
      name="description"
      content={defaultMeta.description}
      key="description"
    />
    <meta name="og:title" content={defaultMeta.title} key="og_title" />
    <meta
      name="og:description"
      content={defaultMeta.description}
      key="og_description"
    />
    <meta name="og:image" content={defaultMeta.image} key="og_image" />

    <meta
      name="facebook-domain-verification"
      content="i0v6q7vlxspo58iuah2ft5c8nl6uwg"
    />
    <meta name="yandex-verification" content="adddda9d001da534" />
    <meta name="yandex-verification" content="d619cae93850847b" />
    <meta name="yandex-verification" content="9ccddcceff13a7b3" />
    <meta
      name="google-site-verification"
      content="GLJUEVM4wYnWdrTJ-F9GS2ljGcBTdLnCqqbHipWxAlc"
    />
    <meta
      name="google-site-verification"
      content="pYNlpx0NmP-PP3MngiTioeAoK0NiCDMt5K-xe9iud_I"
    />
  </Head>
));
